import { ChangeDetectorRef, Component, HostListener, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@app/services/auth.service';
import { ScreenSizeService } from '@app/shared/services/screen-size.service';
import { SCREEN_SIZE } from '@app/shared/types/screen-size.enum';
import { ColumnMode, DatatableComponent, SelectionType } from '@swimlane/ngx-datatable';
import { ToastrService } from 'ngx-toastr';
import { delay } from 'rxjs';
import { io } from 'socket.io-client';

@Component({
  selector: 'app-projects',
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.css']
})
export class ProjectsComponent implements OnInit {
  @ViewChild(DatatableComponent) table: DatatableComponent;
  columns: any[]=[
    {prop:'_id', name:'Index'},
    {prop:'clientName', name:'Client Name'},
    {prop:'industry', name:'Industry'},
    {prop:'contactPersonName', name:'Person Name'},
    {prop:'email', name:'Email'},
    {prop:'phone', name:'Phone'},
    {prop:'captainEmail', name:'Captain'},
    {prop:'isDemoLive', name:'Is Demo'},
    {prop:'demoStartDate', name:'Demo Date'},
    {prop:'liveDate', name:'Live Date'},
    {prop:'sendWhatsapp', name:'Whatsapp Notification'},
    {prop:'status', name:'Status'},
    {prop:'created', name:'Created At'},
    {prop:'action', name:'Action'},
  ];
  rows: any[] = [];
  timeout: any;
  columnMode: ColumnMode = ColumnMode.force;
  SelectionType = SelectionType;
  rowHeight: 'auto' | number = 'auto'
  scrollbarH: boolean = false
  projectList:any[]=[];
  temp:any[]=[];
  selected = [];
  socket: any;

  constructor(private auth: AuthService, private cdr: ChangeDetectorRef, private screenSizeSvc: ScreenSizeService, private router: Router, private toastr: ToastrService) {
    this.screenSizeSvc.onResize$.pipe(delay(0)).subscribe(sizes => {
        const sizeTabletAbove = sizes.includes(SCREEN_SIZE.XXL) ||  sizes.includes(SCREEN_SIZE.XL) || sizes.includes(SCREEN_SIZE.LG)
        if(sizeTabletAbove){
            this.rowHeight = 'auto'
            this.scrollbarH = false
            this.columnMode = ColumnMode.force;
        } else {
            this.rowHeight = 68
            this.scrollbarH = true
            this.columnMode = ColumnMode.force;
        }
        this.cdr.markForCheck()
    });
  }
  
  @HostListener('window:resize', ['$event'])windowResize(event) {
      this.getScreenWidth(event.target.innerWidth)
  }
  getScreenWidth(size:number) {
        this.screenSizeSvc.onResize(size)
  }

  updateFilter(event) {
      const val = event.target.value.toLowerCase();
      const temp = this.temp.filter(function (d) {
          return d.clientName.toLowerCase().indexOf(val) !== -1 || !val;
      });
      this.projectList = temp;
      this.table.offset = 0;
  }
  
  onActivate(event) {
      console.log('Activate Event', event);
  }

  ngOnInit(): void {
    this.getProjects();
    this.socket = io(this.auth.geturl()); // backend URL

    this.socket.on('new-lead', (data:any) => {
        this.getProjects();
      // this.rows.unshift(data); // add new lead at the top
    });
  }
  getProjects(){
    this.auth.getAllProject().subscribe((res:any)=>{
      this.projectList = res;
      this.temp = [...res]
      this.cdr.markForCheck();
      // this.rows = res
      // this.cdr.detectChanges();
      // console.log(this.projectList)
    },(err:any)=>{
      console.log(err);
    })
  }
  onPage(event:any) {
      clearTimeout(this.timeout);
          this.timeout = setTimeout(() => {
          // console.log('paged!', event);
      }, 100);
  }
  editProject(data:any){
    this.router.navigateByUrl('editProject/'+data);
  }
  changePassword(id:any){
    this.auth.changePassword(id).subscribe((res:any)=>{
      this.toastr.success(res.message);
    },(err:any)=>{
      console.log(err);
      this.toastr.error(err.message);
    })
  }
  deleteProject(id:any){
    this.auth.deleteProject(id).subscribe((res:any)=>{
      this.getProjects();
      this.toastr.success(res.message);
    },(err:any)=>{
      console.log(err);
      this.toastr.error(err.message);
    })
  }

}
